import {DistributionsService} from "../../../../service/distributionList.service";
import {UserBasicService} from "../../../../service/users-basic.service";
import {useParams} from "react-router-dom";
import {UpdateDistributionList} from "../../../common/distribution/updateDistributionList";


export default function UpdateDistributionListArauco() {
    const { id } = useParams<{ id: string }>();
    const updateDistributionList = async (id: string, name: string, selectedIds: string[]) => {
        await DistributionsService.update(id, {
            name: name,
            organization: "arauco",
            usersBasic: selectedIds
        })
    };
    const getUsers = async () => {
        return await UserBasicService.findAll();
    };
    const getDistributionList = async () => {
        return await DistributionsService.findOne(id ? id : "");
    }
    return(<UpdateDistributionList onUpdate={updateDistributionList} onGetDistributionList={getDistributionList} onGetUsers={getUsers} id={id} />)
}